@if (notificationsPaginator.data.length > 0) {
    <div class="mb-3">
        Voici vos notifications des 15 derniers jours (passé ce délai, elles sont automatiquement effacées) :
    </div>
}
@for (notification of notificationsPaginator.data; track notification) {
    <div class="alert alert-info alert-with-icon" data-notify="container"
         [ngStyle]="{'borderColor': notification.listing.displayType.backgroundColor, 'color': notification.listing.displayType.bodyColor}">
        <span data-notify="icon" class="tim-icons icon-bell-55"></span>
        <div data-notify="message">
            <span class="bold-text">{{ notification.inserted }}</span>
            <br>
            <div [innerHTML]="displayMessage(notification.notification)"></div>
        </div>
    </div>
}
@if (notificationsPaginator.totalItems > 5) {
    <div>
        <app-paginator></app-paginator>
    </div>
}
